// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 2:19 AM
 */

import type {MenuAction} from "../actions/menu/menuAction";

export type MenuState = {

    open: boolean
};

const INITIAL_STATE: MenuState = {
    open: false
};

export default function reducer(state: MenuState = INITIAL_STATE, action: MenuAction): MenuState {

    switch (action.type) {
        case "menu/MENU_OPEN_ACTION":
            return {
                ...state,
                open: true
            };
        case "menu/MENU_CLOSE_ACTION":
            return {
                ...state,
                open: false
            };
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/MenuReducer.js